import {
  AUTH_CHANGE,
  FETCH_USER,
  TOGGLE_LOGIN,
  AUTH_LOADING,
  SET_CURRENT_USER,
} from './authTypes'

const initialState = {
  loading: false,
  currentUser: false,
  isLoginPage: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH_CHANGE:
      return {
        ...state,
        isAuthenticated: action.payload,
      }
    case FETCH_USER:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
      }
    case SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
      }
    case TOGGLE_LOGIN:
      return {
        ...state,
        isLoginPage: action.payload,
      }
    case AUTH_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}
